export default class SearchFormController {
  /* @ngInject */
  constructor(ConfigurationService, $log, DataService,
    NavigationService, $document, ACT_POSTCODE_PREFIX, NT_POSTCODE_PREFIX,
    PostcodeService) {
    this.$log = $log;
    this.authorable = ConfigurationService.getConfiguration();
    this.states =
      this.constructor.filterUniqueStates(this.authorable.landing_multipleStateListing);
    this.DataService = DataService;
    this.NavigationService = NavigationService;
    this.PostcodeService = PostcodeService;
    this.$document = $document;
    this.ActPostCodePrefix = ACT_POSTCODE_PREFIX;
    this.NtPostCodePrefix = NT_POSTCODE_PREFIX;

    this.multipleStatesAreSelected = false;
    this.showLocationRequiredAlert = false;
    this.locationsHaveBeenReturned = false;
    this.combinedTelstraCustomerWarning = `${this.authorable.landing_telstraCustomerWarning}`
    + `<a href="tel:${this.authorable.landing_telstraContactNumber}"> <b>`
    + `${this.authorable.landing_telstraCustomerWarningNumberToCall}</b></a>`;
  }

  $onInit() {
    // used to initialise the controller when pulling in the persistent data from the DataService
    if (this.formData.postCode) {
      this.preselectStateInMultiCoverage(this.formData.postCode);
      this.handleServerPostCodeValidation(this.formData.postCode, true);
    }
    if (!angular.equals(this.formData, {})) {
      this.checkIfMultipleStatesAreSelected();
    }
  }

  static filterUniqueStates(statesArray) {
    const states = [];
    statesArray.forEach((state) => {
      if (states.indexOf(state.name) === -1 && state.name !== '') {
        states.push(state.name);
      }
    });
    return states;
  }

  validatePostcodeFromForm(postCodeFormObject) {
    const postCodeValueAsString = `${postCodeFormObject.$viewValue}`;
    this.isValidNumber(postCodeFormObject.$viewValue);
    this.showLocationRequiredAlert = false;
    if (this.postCodeIsNumber
      && (postCodeValueAsString.length === 4)
      && postCodeFormObject.$valid) {
      // if postcode is changed and multistate is checked it doesn't make sense to leave it checked
      this.formData.requiresCoverageInMultipleStates = false;
      this.clearAllStatesOnUncheck();
      this.preselectStateInMultiCoverage(postCodeValueAsString);
      this.handleServerPostCodeValidation(postCodeValueAsString);
    } else {
      this.locations = undefined;
    }
  }

  showPostCodeError(form) {
    // if any invalid characters (ie non-numeric)
    return (!this.postCodeIsNumber && form.postCode.$viewValue
     && form.postCode.$viewValue.length <= 4)
      // if the regex pattern fails
      || (form.$submitted && form.$error.pattern)
      // or if the user has input a partial postcode
      || (form.postCode.$touched && this.postCodeIsNumber && form.postCode.$viewValue.length <= 4);
  }

  handleServerPostCodeValidation(postCode, buildFromPersistentData) {
    this.PostcodeService
      .getPostCode(postCode)
      .then((data) => {
        this.data = data;
        this.locations = data.geocodePostcodeList && data.geocodePostcodeList;
        // when there is more than one location returned the select options need to be built
        if (this.locations.length > 1) {
          this.locations = this.constructor.processLocationNames(this.locations);
          this.checkIfMultipleStatesReturned(this.locations);
          this.locationsHaveBeenReturned = true;
          // create a default option which informs the user of the next step
          this.locations.unshift({ id: '0', combinedName: this.authorable.landing_locationSelectDefaultValue, disable: true });
          if (!buildFromPersistentData) {
            // preselect the select box with the default option
            this.formData.myLocation = this.locations[0].id;
          }
        } else {
          this.formData.myLocation = this.locations.length ? `${this.locations[0].locality},${this.locations[0].state}` : '';
        }
      });
  }

  static processLocationNames(locations) {
    function sortStrings(a, b, key) {
      if (a[key] < b[key]) {
        return -1;
      }
      if (a[key] > b[key]) {
        return 1;
      }
      return 0;
    }
    return locations
      .map(location => ({
        postcode: location.postcode,
        locality: location.locality,
        state: location.state,
        id: `${location.locality},${location.state}`,
        combinedName: `${location.locality}, ${location.state}`
      }))
      // sort all localities by state
      .sort((a, b) => sortStrings(a, b, 'state'))
      // then sort localities within a state
      .sort((a, b) => {
        if (a.state === b.state) {
          return sortStrings(a, b, 'locality');
        }
        // allow for a crossover between states and make sure a locality is aligned within a state
        return sortStrings(a, b, 'state');
      });
  }

  checkIfMultipleStatesReturned(locations) {
    const states = [];
    locations.forEach((location) => {
      if (states.indexOf(location.state) === -1) {
        states.push(location.state);
      }
    });
    this.statesLength = states.length;
  }

  /* MULTIPLE-STATE COVERAGE FUNCTIONALITY */

  checkIfMultipleStatesAreSelected() {
    this.multipleStatesAreSelected = this.formData.multiCoverage
      && Object.keys(this.formData.multiCoverage).length >= 2;
  }

  // state: state.name
  // isSelected : returns true if the state is registered in formData.multiCoverage[state.name]
  updateMultiStateSelection(state, isSelected) {
    if (!isSelected) {
      delete this.formData.multiCoverage[state];
    } else {
      this.formData.multiCoverage[state] = true;
    }
    this.checkIfMultipleStatesAreSelected();
  }

  clearAllStatesOnUncheck() {
    if (!this.formData.requiresCoverageInMultipleStates) {
      delete this.formData.multiCoverage;
    }
    // make sure that input postcode is not removed from formData.multiCoverage
    // when multistate checkbox is unchecked
    if (this.formData.postCode) {
      this.preselectStateInMultiCoverage(this.formData.postCode);
    }
  }

  isValidNumber(value) {
    this.postCodeIsNumber = !Number.isNaN(Number(value));
  }

  preselectStateInMultiCoverage(postCode) {
    const statesByPostcodePrefix = this.authorable.landing_multipleStateListing;
    let stateName;
    let postCodeValue;
    if (angular.isNumber(postCode)) {
      postCodeValue = `${postCode}`;
    } else {
      postCodeValue = postCode;
    }
    // 26 is the prefix for ACT, all other states are identified by a single digit prefix
    const statePrefix = postCodeValue.split('').slice(0, 2).join('');
    if (statePrefix === this.ActPostCodePrefix) {
      stateName = statesByPostcodePrefix.find(state => state.key === this.ActPostCodePrefix).name;
    } else if (statePrefix === this.NtPostCodePrefix) {
      stateName = statesByPostcodePrefix.find(state => state.key === this.NtPostCodePrefix).name;
    } else if (statePrefix.split('').slice(0, 1).join('') === '0' || statePrefix.split('').slice(0, 1).join('') === '8' || statePrefix.split('').slice(0, 1).join('') === '9') {
      // if the postcode starts with 0 but is not 08 then it is invalid
      // and we dont want anything to be preset
      return;
    } else {
      stateName = statesByPostcodePrefix
        .find(state => state.key === postCodeValue.split('')[0])
        .name;
    }

    if (this.formData.multiCoverage) {
      this.formData.multiCoverage[stateName] = true;
    } else {
      this.formData.multiCoverage = { [stateName]: true };
    }
  }

  /* FORM VALIDATION */
  updateFormModel(modelName) {
    if (!this.formData.solutions[modelName.key]) {
      delete this.formData.solutions[modelName.key];
      if (angular.equals(this.formData.solutions, {})) {
        delete this.formData.solutions;
      }
    }
  }

  validateSolutions() {
    return this.formData.solutions &&
      Object.keys(this.formData.solutions).length > 0;
  }

  setNoSolutionSelected(bool) {
    this.noSolutionSelected = bool;
  }

  formIsValid(form) {
    this.scrollToInvalidField();
    return this.validateSolutions() && !!form.$valid;
  }

  scrollToInvalidField() {
    let element;
    // sets up form scroll target in order of:
    // 1 - invalid solution
    // 2 - invalid select box
    // 3 - invalid input
    // 4 - invalid state
    if (!this.validateSolutions()) {
      this.setNoSolutionSelected(true);
      element = this.$document[0].querySelector('[class*=visual-picker-wrapper]');
    } else {
      this.setNoSolutionSelected(false);
      element = this.$document[0].querySelector('select.ng-invalid')
        || this.$document[0].querySelector('input.ng-invalid')
        || this.$document[0].querySelector('.state .invalid');
    }

    if (element) {
      const elementClasses = Array.from(element.classList);
      // check for invalid solutions, add scroll offset to take go to the solution tabs
      const solutionsAreInvalid = elementClasses.some(className => className === 'checkbox-wrapper');
      // solutionOffset amount determined by the height of the solution tabs
      // the alternative amount is approximately the distance between
      // the top of the invalid element and the window top
      const solutionOffset = solutionsAreInvalid ? 250 : 100;
      const duration = 500;
      this.$document.scrollToElement(element, solutionOffset, duration);
    }
  }

  onSubmit(formName) {
    if (this.locationsHaveBeenReturned && this.formData.myLocation === '0') {
      this.showLocationRequiredAlert = true;
      this.locationsHaveBeenReturned = false;
    } else if (formName.$valid) {
      this.showLocationRequiredAlert = false;
      if ((this.formData.requiresCoverageInMultipleStates
          && this.multipleStatesAreSelected)
        || !this.formData.requiresCoverageInMultipleStates) {
        this.DataService.setData(this.formData);
        this.NavigationService.navigateToSearchResults();
      }
    } else {
      angular.element(this.$document[0].querySelector('.invalid')).focus();
    }
  }

  /* OTHER FUNCTIONS */

  clearRoleOther() {
    this.formData.myRoleOther = '';
  }
}



// WEBPACK FOOTER //
// ./src/components/search-form/searchForm.controller.js